import { mapState, mapMutations } from 'vuex'
import { getPostById, getPostFormStructure, getPostsByAnnonceur } from '@/services/posts'

/**
 * Mixin pour récupération de l'annonce selon l'ID dans l'URL
 */
export const PostMixin = {
  data () {
    return {
      loading: false,
      post: null
    }
  },
  beforeMount () {
    this.fetchPost()
  },
  watch: {
    '$route.params.post' () {
      this.fetchPost()
    }
  },
  methods: {
    offerTypeChanged () {
      this.getStructure(this.post)
    },
    objectTypeChanged () {
      this.getStructure(this.post)
    },
    async fetchPost () {
      this.loading = true
      this.post = await getPostById(this.$route.params.post)
      this.getStructure && this.getStructure(this.post)
      this.loading = false
    }
  }
}
